// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1Jrzh","messages":"Chat_messages__3ebXM","dateDivider":"Chat_dateDivider__35euM"};